import React from 'react'
import { Button } from './button'

export const PresetButton = ({name, callback} : {name: string, callback: Function}) => (
  <Button name={name} styling={{
    size: 12,
    padding: 16,
    separation: 12,
  }} action={() => {
    fetch(`text/${name.toLowerCase()}.txt`).then(async (res) => {
      if (res.ok) {
        callback(await res.text())
      }
    })
  }} />
)